module.exports = __webpack_public_path__ + "img/17.b20e117c.jpg";